import { BaseScatola, sx } from '@lucan/base-ui'
import Sottotitolo from './Sottotitolo'
import Titoletto from './Titoletto'

export default function Sezione(props) {
  const { titolo, sottotitolo, children, ...rest } = props

  return (
    <BaseScatola {...rest} {...sx(rest, { bgcolor: 'grey.200' })}>
      {titolo && <Titoletto variant='h4'>{titolo}</Titoletto>}
      {sottotitolo && <Sottotitolo sx={{ mb: 1 }}>{sottotitolo}</Sottotitolo>}
      {children}
    </BaseScatola>
  )
}